import React, { useEffect, useState } from 'react'
import { Modal, Row, Col, SelectPicker, Checkbox, Message } from 'rsuite'
import { saveWarningDetail, searchWarningDetail } from '../../redux/actions/dashboard'
import { cloneDeep } from 'lodash-es'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function WarningDetailWidgets({ title = '', cancleBtn = 'ปิด', ...props }) {
  const { show, onCancle, projectCode, periodNumber } = props
  const [schema, setSchema] = useState()
  const [showMore, setShowMore] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [checked, setChecked] = useState([])
  const [msgError, setMsgError] = useState()

  useEffect(() => {
    console.log('call schema ', show, projectCode, periodNumber)

    if (show) {
      //call schema

      setShowMore(0)
      setMsgError()

      handleSearch({
        projectCode: projectCode || null,
        periodNumber: periodNumber || null,
        statusId: null,
      })
    }
  }, [show])

  const handleSearch = async (request, failIds) => {
    setIsLoading(true)

    try {
      const response = await searchWarningDetail(request)
      // console.log('ressss => ', response)

      setSchema(response)
      setChecked(failIds || [])
    } catch (error) {
      console.log('error => ', error)
    }
    setIsLoading(false)
  }

  const handleOnClick = async () => {
    // setIsSelfLoading(true)
    // onConfirm()
    setMsgError('')
    const chk = checked?.length || 0
    if (chk == 0) {
      setMsgError('กรุณาเลือกรายการที่ดำเนินการเสร็จแล้วก่อน')
      return false
    }

    setIsLoading(true)

    try {
      const request = {
        projectCode: projectCode,
        periodNumber: periodNumber || null,
        id: checked,
      }

      const response = await saveWarningDetail(request)

      if (response?.successAll) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        handleSearch({
          projectCode: projectCode || null,
          periodNumber: periodNumber || null,
          statusId: null,
        })
      } else {
        let failIds = []
        response?.fails?.forEach((e) => {
          failIds.push(e.id)
        })

        if (failIds?.length > 0) {
          setMsgError('Update บางรายการไม่สำเร็จ')
        }

        handleSearch(
          {
            projectCode: projectCode || null,
            periodNumber: periodNumber || null,
            statusId: null,
          },
          failIds
        )
      }
    } catch (error) {
      //console.log('error => ', error)
      setMsgError(DEFAULT_ERR_MSG)
    }

    setIsLoading(false)
  }

  const handelShow = (id) => {
    setShowMore(id)
  }

  const handleChangeStatus = (statusId) => {
    setMsgError()

    const req = {
      projectCode: projectCode || null,
      statusId: statusId != 99 ? statusId : null,
      periodNumber: periodNumber || null,
    }

    handleSearch(req)
  }

  const onCheckChange = (refId, chk) => {
    // console.log('onCheckChange => ', refId, chk)

    if (chk) {
      let newArr = cloneDeep(checked || [])

      newArr.push(refId)
      setChecked(newArr)
      setMsgError()
    } else {
      const index = checked.indexOf(refId)
      let newArr = cloneDeep(checked || [])

      if (index > -1) {
        newArr.splice(index, 1)
        setChecked(newArr)
      }
    }
  }

  return (
    <>
      {schema && (
        <Modal backdrop={'static'} full show={show} onHide={onCancle}>
          <Modal.Header>
            <Modal.Title>
              <p style={{ paddingTop: '0.5rem' }}>{schema?.title || title}</p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div style={{ padding: 10 }}>
              {/* {schema?.values.length > 0 && ( */}
              <Row>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                  {schema.statusOptions.label}
                  <SelectPicker
                    searchable={false}
                    data={schema.statusOptions.options}
                    value={props.value}
                    style={{ width: 250, marginLeft: 5 }}
                    disabled={isLoading}
                    placeholder="เลือก"
                    onChange={(value) => {
                      // console.log('value => ', value)
                      // props.onChange(value)
                      handleChangeStatus(value)
                      // onChangeMainProject(value)
                    }}
                  />
                </Col>
              </Row>
              {/* )} */}

              <Row style={{ marginTop: 20 }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <table border={1} width={'100%'}>
                    <tr>
                      <th>
                        <div style={{ padding: 8 }}>เลือก</div>
                      </th>
                      <th>
                        <div style={{ padding: 8 }}>ประเภทภาพรวมข้อคิดเห็น</div>
                      </th>
                      <th>
                        <div style={{ padding: 8 }}>ระดับความมีสาระสำคัญ</div>
                      </th>
                      <th>
                        <div style={{ padding: 8 }}>รายละเอียด</div>
                      </th>
                      <th>
                        <div style={{ padding: 8 }}>สถานะ</div>
                      </th>
                      <th>
                        <div style={{ padding: 8 }}>ชื่่อผู้ตรวจสอบ</div>
                      </th>
                    </tr>
                    {isLoading ? (
                      <>
                        <tr>
                          <th colSpan={6}>
                            <div style={{ padding: 8, color: '#808080' }}>... Loading ...</div>
                          </th>
                        </tr>
                      </>
                    ) : (
                      <>
                        {schema?.values.length > 0 ? (
                          schema?.values?.map((item, index) => {
                            const open = item.id === showMore

                            return (
                              <tr key={index} style={{ verticalAlign: 'top' }}>
                                <td width={'5%'} style={{ verticalAlign: '' }}>
                                  <div
                                    style={{
                                      // padding: 8,
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {item.enabled && (
                                      <Checkbox
                                        key={item.refId}
                                        checked={checked?.includes(item.refId)}
                                        onChange={(e, checked) => {
                                          onCheckChange(item.refId, checked)
                                        }}
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width={'10%'} align="center">
                                  <div style={{ padding: 8 }}>{item.overviewType}</div>
                                </td>
                                <td width={'20%'} align="center">
                                  <div style={{ padding: 8 }}>{item.priority}</div>
                                </td>
                                <td width={'30%'}>
                                  <div style={{ padding: 8 }}>
                                    {item.detail.length <= 80 ? (
                                      item.detail
                                    ) : (
                                      <>
                                        <p style={{ wordWrap: 'break-word' }}>
                                          {open
                                            ? item.detail
                                            : `${item.detail.substring(0, 80)}...`}
                                        </p>
                                      </>
                                    )}

                                    {open ? (
                                      <>
                                        {item.detail.length >= 80 && (
                                          <p
                                            style={{
                                              cursor: 'pointer',
                                              color: '#2da888',
                                              fontSize: 12,
                                              fontWeight: 'bold',
                                            }}
                                            onClick={() => handelShow(0)}
                                          >
                                            {`<แสดงน้อยลง>`}
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {item.detail.length >= 80 && (
                                          <p
                                            style={{
                                              cursor: 'pointer',
                                              color: '#2da888',
                                              fontSize: 12,
                                              fontWeight: 'bold',
                                            }}
                                            onClick={() => handelShow(item.id)}
                                          >
                                            {`<คลิกอ่านเพิ่มเติม>`}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </td>
                                <td width={'15%'}>
                                  <div style={{ padding: 8 }}>{item.statusName}</div>
                                </td>
                                <td width={'20%'} align="center">
                                  <div
                                    style={{ padding: 8 }}
                                    dangerouslySetInnerHTML={{
                                      __html: `${item.auditName} <br /> <div style="font-size: 14px; color: #434141;">(${item.createDate})</div>`,
                                    }}
                                  />
                                  {/* <div style={{ padding: 8 }} dangerouslySetInnerHTML={{ __html: item.children }} />{item.auditName}</div> */}
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <tr>
                            <th colSpan={6}>
                              <div style={{ padding: 8, color: '#808080' }}>
                                ... ไม่พบข้อมูล ...
                              </div>
                            </th>
                          </tr>
                        )}
                      </>
                    )}
                  </table>
                </Col>
              </Row>
            </div>
          </Modal.Body>

          <Modal.Footer>
            {msgError && (
              <Message
                showIcon
                closable
                type="error"
                description={msgError}
                style={{ textAlign: 'left', marginBottom: 5 }}
                onClose={() => {
                  setMsgError('')
                }}
              />
            )}
            <div style={{ marginRight: 10 }}>
              {schema?.values?.filter((e) => ['0', '4', '5'].includes(e.statusId))?.length > 0 && (
                <SaveButton
                  onClick={handleOnClick}
                  loading={isLoading}
                  disabled={isLoading}
                  children="ดำเนินการแล้ว"
                />
              )}
              <CancelButton onClick={onCancle} children={cancleBtn} />
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}
